/*
 * Dreamy — tiroir panier : « Passer au Duo » (S7) et housse de rechange facultative.
 * Passer au Duo : /cart/change.js (retire un Essentiel) puis /cart/add.js (ajoute le Duo, avec les sections
 * du tiroir), puis rafraîchissement du tiroir Dawn (renderContents). Un seul upsell.
 */
(function () {
  var SECTIONS = 'cart-drawer,cart-icon-bubble';

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body),
    }).then(function (r) {
      return r.json().then(function (json) {
        if (!r.ok || json.status) throw new Error(json.description || json.message || 'Erreur panier');
        return json;
      });
    });
  }

  function refresh(state) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function' && state && state.sections) {
      drawer.renderContents(state);
    }
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'dreamy-cart-upsell', cartData: state });
    }
  }

  function fail(button, err) {
    var box = button.closest('.dr-upsell');
    var msg = box && box.querySelector('.dr-upsell__msg');
    if (msg) msg.textContent = (window.dreamyConfig && dreamyConfig.strings.error) || err.message;
    button.removeAttribute('aria-disabled');
    button.classList.remove('loading');
  }

  function busy(button) {
    if (button.getAttribute('aria-disabled') === 'true') return false;
    button.setAttribute('aria-disabled', 'true');
    button.classList.add('loading');
    return true;
  }

  document.addEventListener('click', function (evt) {
    var duo = evt.target.closest('[data-dreamy-upsell-duo]');
    if (duo) {
      evt.preventDefault();
      if (!busy(duo)) return;
      if (window.Dreamy && Dreamy.track) Dreamy.track('dreamy_upsell_duo_click', {});
      var qty = parseInt(duo.getAttribute('data-quantity'), 10) || 1;
      post(window.routes.cart_change_url + '.js', { id: duo.getAttribute('data-line-key'), quantity: qty - 1 })
        .then(function () {
          return post(window.routes.cart_add_url + '.js', {
            items: [{ id: Number(duo.getAttribute('data-duo-id')), quantity: 1 }],
            sections: SECTIONS,
            sections_url: window.location.pathname,
          });
        })
        .then(refresh)
        .catch(function (err) {
          fail(duo, err);
        });
      return;
    }

    var cover = evt.target.closest('[data-dreamy-add-cover]');
    if (cover) {
      evt.preventDefault();
      if (!busy(cover)) return;
      post(window.routes.cart_add_url + '.js', {
        items: [{ id: Number(cover.getAttribute('data-dreamy-add-cover')), quantity: 1 }],
        sections: SECTIONS,
        sections_url: window.location.pathname,
      })
        .then(refresh)
        .catch(function (err) {
          fail(cover, err);
        });
    }
  });
})();
